import { render } from "./FormCounterButtons.vue?vue&type=template&id=65efeaee"
import script from "./FormCounterButtons.vue?vue&type=script&lang=js"
export * from "./FormCounterButtons.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aquis/vue-modules/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__